import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { contactus } from 'src/app/core/translations/contactus';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-release',
  templateUrl: './new-release.component.html',
  styleUrls: ['./new-release.component.scss']
})
export class NewReleaseComponent implements OnInit {

  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';
  currentLanguage: string = '';
  languageTranslations: any = contactus;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        //console.log(this.activeLanguageTranslations);
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
